export const UNBOUND_CUSTOMER = '__unbound__';
export const UNSPECIFIED_PLATFORM = '__none__';
export const UNKNOWN_CREATOR = '__unknown__';

export interface LinkFilters {
  customer: string[];
  platform: string[];
  template: string[];
  status: string[];
  creator: string[];
  traffic: string[];
}

export const EMPTY_LINK_FILTERS: LinkFilters = {
  customer: [],
  platform: [],
  template: [],
  status: [],
  creator: [],
  traffic: [],
};

interface FilterableLink {
  id: string;
  name: string;
  domain: string;
  realUrl: string;
  decoyUrl: string;
  billingUnitId: string | null;
  billingUnitName: string | null;
  platform: string;
  template: string;
  status: string;
  createdBy: string;
}
interface TrafficStats {
  real: number;
  audit: number;
  realToday: number;
  auditToday: number;
}

export function matchesLinkFilters(
  link: FilterableLink,
  filters: LinkFilters,
  search: string,
  stats?: TrafficStats,
  statsReady = true,
) {
  const normalize = (value: string) => value.normalize('NFKC').toLowerCase();
  const query = normalize(search.trim());
  if (
    query &&
    !normalize(
      `${link.name} ${link.id} ${link.domain} ${link.realUrl} ${link.decoyUrl} ${link.billingUnitName ?? ''}`,
    ).includes(query)
  )
    return false;
  const fields = {
    customer: link.billingUnitId || UNBOUND_CUSTOMER,
    platform: link.platform || UNSPECIFIED_PLATFORM,
    template: link.template,
    status: link.status,
    creator: link.createdBy || UNKNOWN_CREATOR,
  };
  for (const key of ['customer', 'platform', 'template', 'status', 'creator'] as const) {
    if (filters[key].length && !filters[key].includes(fields[key])) return false;
  }
  if (!filters.traffic.length) return true;
  if (!statsReady) return false;
  return filters.traffic.some((value) =>
    value === 'todayActive'
      ? !!stats && stats.realToday + stats.auditToday > 0
      : value === 'zero' && (!stats || stats.real + stats.audit === 0),
  );
}
